import React from 'react';
import { BoltIcon, EnvelopeIcon, MicrophoneIcon } from '../icons';
import {
  ActionButtonContainer,
  CreatePendingPatientContextButton,
  DashedDivider,
  FlexEndWrapper,
  HeaderIconButton,
  OpenZoomButton,
  SpaceBetweenWrapper
} from '../common';
import { ViewReportButton } from '@/components/contextActions/patientDetails/ViewReportButton';
import { PrintReportButton } from '@/components/contextActions/patientDetails/PrintReportButton';
import { TemplateDrawerButton } from '@/components/contextActions/patientDetails/TemplateDrawerButton';
import { CustomDocumentDrawerButton } from '@/components/contextActions/patientDetails/CustomDocumentDrawerButton';
import { PatientsAppToggle } from '@/components/contextActions/patientDetails/PatientsAppToggle';
import { SearchPatientField } from '@/components/search';
import dynamic from 'next/dynamic';
import { useCurrentHospital } from '@/modules/appContext';

const LifenExportButton = dynamic(
  () => import('./LifenExportButton').then((mod) => mod.LifenExportButton),
  { ssr: false }
);

const TimeTracker = dynamic(
  () => import('./TimeTracker').then((mod) => mod.TimeTracker),
  { ssr: false }
);

export const PatientDetailsContextActions = ({
  isUsapHospital
}: {
  isUsapHospital?: boolean;
}) => {
  const {
    lifenModuleEnabled: lifenEnabled,
    timeTrackingModuleEnabled: timeTrackingEnabled,
    patientsAppModuleEnabled: patientsAppEnabled,
    customDocumentModuleEnabled: customDocumentEnabled
  } = useCurrentHospital()?.queryResult?.data ?? {};

  return (
    <SpaceBetweenWrapper>
      <SearchPatientField globalSearchModeOnly />
      <FlexEndWrapper>
        <ActionButtonContainer>
          {timeTrackingEnabled && <TimeTracker />}
          {patientsAppEnabled && <PatientsAppToggle />}
          {isUsapHospital === false && (
            <>
              <HeaderIconButton disabled icon={<BoltIcon />} />
              {/*<HeaderIconButton disabled icon={<BookmarkIcon />} />*/}
              {/*<HeaderIconButton disabled icon={<FireIcon />} />*/}
              <OpenZoomButton />
              {/*<HeaderIconButton disabled icon={<ChatIcon />} />*/}
              <HeaderIconButton disabled icon={<MicrophoneIcon />} />
              <HeaderIconButton disabled icon={<EnvelopeIcon />} />
            </>
          )}
          <TemplateDrawerButton />
          {customDocumentEnabled && <CustomDocumentDrawerButton />}
          {lifenEnabled && <LifenExportButton />}
          {isUsapHospital === false && (
            <>
              <ViewReportButton />
              <PrintReportButton />
            </>
          )}
          {isUsapHospital === false && <CreatePendingPatientContextButton />}
        </ActionButtonContainer>
        <DashedDivider />
      </FlexEndWrapper>
    </SpaceBetweenWrapper>
  );
};
